import { cn } from '@/shared/lib/cn';

interface PublicInviteRichTextProps {
  html: string;
  className?: string;
}

/**
 * Termos e regras de fidelidade vêm como HTML cru do passbook (`<p style="...">`,
 * `<a href>`, `<ul><li>`, `<center>`…) — o legado usa `<%- %>` (unescaped) +
 * troca `\n` por `<br/>` antes de renderizar (views/invite.ejs). Replicamos os
 * dois. `dangerouslySetInnerHTML` é seguro aqui: o conteúdo vem da configuração
 * da própria loja no nosso backend, não de input livre de usuário externo.
 */
export function PublicInviteRichText({ html, className }: PublicInviteRichTextProps) {
  const withBreaks = html.replace(/\n/g, '<br/>');
  return (
    <div
      className={cn(
        'max-w-full overflow-x-hidden text-sm text-muted-foreground [overflow-wrap:anywhere]',
        '[&_a]:text-primary [&_a]:underline [&_a]:underline-offset-2',
        '[&_h6]:mt-3 [&_h6]:text-sm [&_h6]:font-semibold [&_h6]:text-foreground [&_h6:first-child]:mt-0',
        '[&_p]:mt-2 [&_p:first-child]:mt-0',
        '[&_ul]:mt-2 [&_ul]:list-disc [&_ul]:pl-5',
        '[&_li]:mt-1',
        '[&_center]:block [&_center]:text-center',
        className,
      )}
      dangerouslySetInnerHTML={{ __html: withBreaks }}
    />
  );
}
